import * as auth from './auth';
import * as user from './user';

export const mainClient = {
  auth,
  user,
};